<template>
  <div class="custom-theme-wrapper">
    <v-main>
      <v-overlay :value="$storeBourse.loader">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <NonAutorise v-show="!$storeBourse.utilisateurConnecte" />
      <v-stepper
        v-model="e1"
        class="stepper_bourse"
        v-show="$storeBourse.utilisateurConnecte"
      >
        <v-row>
          <v-col cols="3">
            <v-row>
              <v-col cols="12">
                <v-btn medium @click="Retour"> RETOUR A LA LISTE </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-stepper-header id="stepper-header">
                  <template
                    v-for="(header, index) in $storeUm6p.Label.StepperHeaders"
                  >
                    <v-stepper-step
                      style="cursor:pointer;"
                      color="ecSecondary"
                      :key="'stepper' + index"
                      :complete="e1 > index + 1"
                      :step="index + 1"
                      v-on:click="Suivant(index+1)"
                    >
                      {{ header }}
                    </v-stepper-step>
                    <v-divider :key="'divider' + index" />
                  </template>
                </v-stepper-header>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="content-stepper" cols="9">
            <v-row class="v-stepper-content" id="stepper-content-ecc">
              <v-col cols="12">
                <v-stepper-items>
                  <v-stepper-content step="1" class="scrollable">
                    <h2>Formulaire de candidature ECC</h2>
                    <v-spacer></v-spacer>
                    <v-divider></v-divider>
                    <small>
                      Conformément à la loi 09-08, vous disposez d’un droit
                      d’accès, de rectification et d’opposition au traitement
                      de vos données personnelles. Ce traitement a été
                      autorisé par la CNDP sous le numéro A-PO-194/2024.
                    </small>
                    <v-checkbox
                      :rules="$storeReglesBourse.obligatoire"
                      v-model="
                        $storeBourse.DonneesFormulaireEC.conditionsGenerales
                      "
                      @change="ConditionsGeneralesChange()"
                      input-value="true"
                      :readonly="$storeBourse.DonneesFormulaireEC.readOnly" 
                    >
                      <template v-slot:label>
                        <span>
                          Cochez ici pour accepter les
                          <a target="_blank" :href="LienRgpd" @click.stop>
                            conditions générales d'utilisation des données
                            personnelles</a
                          ></span
                        >
                      </template>
                    </v-checkbox>
                  </v-stepper-content>
                  <v-stepper-content custom step="2" class="scrollable">
                    <Candidat :affichageAutreRevenu="affichageAutreRevenu" ref="refCandidat" />
                  </v-stepper-content>
                  <v-stepper-content step="3" class="scrollable">
                    <Fratrie ref="refFratrie" />
                  </v-stepper-content>
                  <v-stepper-content step="4" class="scrollable">
                    <Parents ref="refParents" />
                  </v-stepper-content>
                  <v-stepper-content step="5" class="scrollable">
                    <Revenus ref="refRevenus" />
                  </v-stepper-content>
                  <v-stepper-content step="6" class="scrollable">
                    <Publipostage ref="refPublipostage" />
                  </v-stepper-content>
                </v-stepper-items>
                <v-row>
                  <v-col cols="6">
                    <v-btn
                      large
                      dark
                      color="ecSecondary"
                      v-if="e1 > 1"
                      @click.native="Precedent()"
                    >
                      {{ $storeUm6p.Label.Precedent }}
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn
                      v-if="e1 < $storeUm6p.Label.StepperHeaders.length"
                      large
                      dark
                      color="ecSecondary"
                      @click.native="Suivant(e1+1)"
                      :disabled="!ShowSuivant && e1==1"
                    >
                      {{ $storeUm6p.Label.Suivant }}
                    </v-btn>
                    <v-row v-else>
                      <v-col cols="6">
                        <v-btn
                          large
                          dark
                          color="ecSecondary"
                          v-show="
                            !this.$storeBourse.DonneesFormulaireEC.readOnly &&
                            !this.$refs.refPublipostage.urlDocument &&
                            !this.cni
                          "
                          @click="Soumettre()"
                        >
                          {{ $storeUm6p.Label.Soumettre }}
                        </v-btn>
                      </v-col>
                      <v-col cols="6">
                        <v-btn
                          large
                          dark
                          color="ecSecondary"
                          v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
                          @click.native="Suivant(6)"
                        >
                          {{
                            !cni
                              ? $storeUm6p.Label.Enregistrer
                              : "Envoyer mon dossier"
                          }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-dialog
                  v-model="$storeBourse.dialog.informations.model"
                  width="500"
                  transition="dialog-bottom-transition"
                >
                  <v-card class="text-center">
                    <v-card-title class="justify-center">
                      <h3>{{ $storeUm6p.Label.Informations }}</h3>
                    </v-card-title>
                    <v-card-text>
                      <p v-html="$storeBourse.dialog.informations.texte"></p>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="ecPrimary"
                        text
                        @click="$storeBourse.dialog.informations.model = false"
                      >
                        {{ $storeUm6p.Label.Fermer }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-stepper>
    </v-main>
  </div>
</template>
<script>
import Candidat from "@/components/BourseEcoleCentrale/Candidat";
import Fratrie from "@/components/BourseEcoleCentrale/Fratrie";
import Parents from "@/components/BourseEcoleCentrale/ParentTuteur";
import Revenus from "@/components/BourseEcoleCentrale/Revenu";
import Publipostage from "@/components/BourseEcoleCentrale/Publipostage";

import NonAutorise from "@/components/PageNonAutoriseExtranet";
export default {
  name: "FicheBourse",
  components: {
    NonAutorise,
    Candidat,
    Fratrie,
    Parents,
    Revenus,
    Publipostage,
  },
  data() {
    return {
      e1: 1,
      $storeBourse: this.$storeBourse,
      $storeCatalogue: this.$storeCatalogue,
      cni: null,
      token: "",
      originalTheme: null,
      affichageAutreRevenu: true,
      LienRgpd: null,
      ShowSuivant: false,
    };
  },
  created() {},
  methods: {
    ConditionsGeneralesChange() {
      if (this.$storeBourse.DonneesFormulaireEC.conditionsGenerales) {
        this.ShowSuivant = true;
      } else {
        this.ShowSuivant = false;
      }
    },
    Retour() {
      this.$router.push("/listebourses?t=" + this.token);
    },
    async GetFiche(id) {
      await this.$storeBourse.GetFiche(id, this.token);
      this.ConditionsGeneralesChange();
    },
    ChargerCatalogues() {
      this.$storeCatalogue.ChargerCatalogueCandidatureBourseEcoleCentrale();
    },
    Enregistrer() {
      if (!this.$storeBourse.DonneesFormulaireEC.readOnly) {
        // Enregistrer les données.
        this.$storeBourse.EnregistrerEtape(this.e1, this.token);
      }
    },
    Suivant(etape) {

      this.$storeBourse.dialog.informations.model=false;
      this.$storeBourse.dialog.informations.texte="";

      if(etape > 4){
        let retour = this.$storeBourse.VerifierTuteur(true, this.$storeCatalogue);
        if(retour.model != undefined){
          this.$storeBourse.dialog.informations = retour;
          this.e1 = 4;
          return false;
        }
      }
      
      this.Enregistrer();
      if (etape <= this.$storeUm6p.Label.StepperHeaders.length) {
        this.e1 = etape;
      }
    },
    Precedent() {
      this.Enregistrer(0);
      this.e1--;
    },
    Soumettre() {
      // Vérifier les champs obligatoires
      let listeErreurs = [];
      
      for (let i = 1; i <= this.$storeUm6p.Label.StepperHeaders.length; i++) {
        let newListe = this.VerifierEtape(i);
        
        if (newListe.length > 0) {
          listeErreurs = listeErreurs.concat(newListe).flat();
        }
        
      }
      
      if (listeErreurs.length > 0) {
        this.$storeBourse.AfficherListeErreurs(listeErreurs);
      } else {
        this.$refs.refPublipostage.Publiposter(this.token);
      }
    },
    VerifierEtape(etape) {
      let liste = [];
      switch (etape) {
        case 2:
          liste = this.$refs.refCandidat.ValiderForm();
          break;
        case 4:
          liste = this.$storeBourse.VerifierTuteur(false, this.$storeCatalogue);
          break;
        case 5:
          liste = this.$refs.refRevenus.ValiderForm();
          break;
        case 6:
          liste = this.VerifierAnnexes();
          break;
      }
      return liste;
    },
    VerifierAnnexes() {
      let listeErreurs = [];
      
      if (
        this.$storeBourse.DonneesFormulaireEC.listeAnnexesFirsi.filter(
          (item) => {
            return item.obligatoireSoumettre == true && !item.nomFichier;
          }
        ).length > 0
      ) {
        listeErreurs.push(this.$storeUm6p.Label.Annexes.AnnexesObligatoires);
        if(this.$storeBourse.DonneesFormulaireEC.ecoleCentrale)
        {
          listeErreurs.push(this.$storeUm6p.Label.Annexes.SoumissionAnnexes);
        }
      }

      return listeErreurs;
    },
  },
  mounted() {
    this.ChargerCatalogues();
    let id = this.$route.params.id;
    let token = this.$route.query.t;
    this.cni = this.$route.query.cni;
    this.LienRgpd = process.env.VUE_APP_URL_CNDP_ECC;

    if (!this.cni) {
      if (token) {
        this.token = token.replace(/\s/g, "+");
        this.$storeBourse.AffecteToken(this.token);
      }
      this.GetFiche(id);
    }
  },
};
</script>
<style scoped src="@/assets/css/DemandeBourse.css">
.custom-theme-wrapper {
  /* Applique les variables CSS du thème custom */
  --v-ecPrimary-base: #0c2251 !important;
  --v-secondary-base: #ff0000 !important;
  --v-accent-base: #a5cffd !important;
}
</style>
